import EstimateOverviewButton from "components/Buttons/EstimateOverviewButton/EstimateOverviewButton";
import CardSeparator from "components/CardSeparator/CardSeparator";
import Counter from "components/Counter/Counter";
import CardOverlay from "features/product/disableReason/CardOverlay";
import { ReturnCells } from "features/selection/BioCode/BioCode";
import { React, useEffect, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configurationsSelector } from "_store/configurations/selectors";
import {
  cloneConfiguration,
  deleteConfiguration,
  editConfiguration,
  newConfiguration,
  setConfigurationQuantity,
} from "_store/configurations/service";
import { useGetLocalizationText } from "_store/localization/selectors";
import { useActivePage } from "_store/page/selectors";
import { useGetSelectedRegionObject } from "_store/session/selectors";
import { bioCodeFormater, summarySelector } from "_store/summary/selectors";
import { priceFormater } from "__utilities/functions/Public";
import { useIsSmallScreen } from "__utilities/hooks/useIsSmallScreen";
import { chooseRangePage, summaryPage } from "__utilities/PageStepEnum";
import EstimateOverviewCard from "./EstimateOverviewCard";
import "./EstimateOverviewElement.css";
import EstimateOverviewElementDetails from "./EstimateOverviewElementDetails/EstimateOverviewElementDetails";
import InputField from "components/InputField/InputField";
import useDidMountEffect from "__utilities/hooks/useDidMountEffect";

export default function EstimateOverviewElement({
  children,
  configuration,
  imageUrl,
  refreshList,
  isLocked,
  type,
  readOnlyMode,
  defaultItemsStyle = {},
  onHideItems = (dispatch) => {
    if (dispatch) dispatch();
  },
}) {
  const [biocodeValue, setBiocodeValue] = useState("");

  const summary = useRecoilValue(summarySelector);
  const [isDetailsShown, setIsDetailsShown] = useState(false);
  const [isPopUpShown, setIsPopUpShown] = useState(false);
  const getLocalizationText = useGetLocalizationText();
  const { setPage } = useActivePage();

  const [itemsStyle, setItemsStyle] = useState(defaultItemsStyle);

  const handleOnClick = (state) => {
    if (state) {
      setIsDetailsShown(state);
    } else {
      onHideItems(() => {
        setIsDetailsShown(state);
      }, setItemsStyle);
    }
  };

  const regionObj = useGetSelectedRegionObject();

  const setConfiguration = useSetRecoilState(configurationsSelector);

  const isSmallScreen = useIsSmallScreen();

  const copyToClipboard = () => {
    let delimiter = window.location.href?.includes('?') === true ? '&' : '?';
    navigator.clipboard.writeText(
      window.location.href + `${delimiter}biocode=` + configuration.bioCodeValue
    );
  };

  function getBiocodeFromURLLocal(url) {
    const urlObj = new URL(url);
    const biocode = urlObj.searchParams.get("biocode");
    return biocode;
  }

  useEffect(
  () => {
      if (document.hasFocus()) {
        if (biocodeValue && biocodeValue.toLowerCase().startsWith('http')) {
          let biocode = getBiocodeFromURLLocal(biocodeValue);
          if (biocode) {
              setBiocodeValue(biocode);
          }
        }
      };
    },
    [biocodeValue]
  );

  return (
    <EstimateOverviewCard>
      {type === "create" ? (
        <>
          <div className="estimate-overview-configuration-create-container">
            <div className="estimate-overview-configuration-create-inner-wrapper">
              <EstimateOverviewButton
                onClick={() => {
                  newConfiguration(() => {
                    setPage(chooseRangePage);
                  });
                }}
              >
                +
              </EstimateOverviewButton>
              <span className="estimate-overview-configuration-create-text">
                {children}
              </span>
            </div>
            <div className="estimate-overview-configuration-create-inner-wrapper">
              <div className="estimate-overview-configuration-create-inner-wrapper-input">
                <InputField
                  value={biocodeValue}
                  onChange={(event) => {
                    setBiocodeValue(event.target.value);
                  }}
                  style={{ display: "flex", alignItems: "center" }}
                />
              </div>
              <EstimateOverviewButton
                onClick={() => {
                  let delimiter = window.location.href?.includes('?') === true ? '&' : '?';
                  window.location.href = window.location.href + `${delimiter}biocode=` + biocodeValue
                }}
              >
                +
              </EstimateOverviewButton>
              <span className="estimate-overview-configuration-create-text">
                {getLocalizationText(
                  "EstimateOverview_AddConfiguration_BioCode"
                )}
              </span>
            </div>
          </div>
        </>
      ) : (
        <div className="estimate-overview-element-container">
          {summary && !isDetailsShown && <div className="estimate-overview-edit-label" onClick={() => handleOnClick(!isDetailsShown)}>
              <p>{getLocalizationText("EstimateOverview_EditProduct")}</p>
            </div>}
          <div
            className={
              "estimate-overview-element-container-row" +
              (isSmallScreen ? " smallScreen" : "")
            }
          >
            {isPopUpShown ? (
              <CardOverlay
                style={{ height: "130px" }}
                text={getLocalizationText("EstimateOverview_ConfirmDelete")}
                type={"confirmation"}
                action={(result) => {
                  if (result === "yes") {
                    deleteConfiguration(configuration.id, refreshList);
                  }
                  setTimeout(() => {
                    setIsPopUpShown(false);
                  }, 10);
                }}
              />
            ) : (
              <>
                <div className="estimate-overview-element-content-container-wrapper">
                  {!readOnlyMode && (
                    <Counter
                      rotated={isSmallScreen}
                      value={configuration?.quantity}
                      minValue={1}
                      maxValue={null}
                      onChange={(value) => {
                        setConfigurationQuantity(
                          configuration?.id,
                          value,
                          () => {
                            setConfiguration(null); // clearing configurations
                            refreshList();
                          }
                        );
                      }}
                      isSelected={true}
                    />
                  )}
                  <div
                    className={
                      "estimate-overview-element-content-container" +
                      (isSmallScreen ? " smallScreen" : "")
                    }
                  >
                    <img
                      className={
                        "estimate-overview-element-image" +
                        (isSmallScreen ? " smallScreen" : "")
                      }
                      src={imageUrl}
                      alt=""
                    />
                    <div className="estimate-overview-element-info-container">
                      <div className="estimate-overview-element-info-title">
                        {configuration.productName}
                      </div>
                      <div className="estimate-overview-element-info-price">
                        {configuration?.quantity}
                        {" x "}
                        {priceFormater(
                          configuration.price.amount,
                          configuration.totalPrice.currencyCode,
                          regionObj?.localizationISOCode,
                          regionObj?.currencyPosition
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {isSmallScreen && <CardSeparator />}
                <div
                  className={
                    "estimate-overview-element-code-container" +
                    (isSmallScreen ? " smallScreen" : "")
                  }
                >
                  <div className="estimate-overview-element-code-title">
                    {getLocalizationText(
                      "EstimateOverview_BioCode_Title"
                    ).replace("[#0#]", configuration.productName)}
                  </div>
                  {ReturnCells(bioCodeFormater(configuration.bioCode))}
                </div>
              </>
            )}
          </div>
          <div className="estimate-overview-element-container-sub-row">
            <div className="estimate-overview-element-info-title">
              {configuration.productName}
            </div>
            <div className="estimate-overview-element-info-price">
              {configuration?.quantity}
              {" x "}
              {priceFormater(
                configuration.price.amount,
                configuration.totalPrice.currencyCode,
                regionObj?.localizationISOCode,
                regionObj?.currencyPosition
              )}
            </div>
            <div
              className={
                "estimate-overview-element-code-container" +
                (isSmallScreen ? " smallScreen" : "")
              }
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              {ReturnCells(bioCodeFormater(configuration.bioCode))}
            </div>
            
          </div>
          {isDetailsShown && (
            <div
              className="estimate-overview-element-code-extendable-container"
              style={{ ...itemsStyle }}
            >
              <EstimateOverviewElementDetails
                key={configuration?.details[0].code}
                configurationId={configuration?.details[0].id}
                title={configuration?.details[0].title}
                details={configuration?.details[0].details}
                code={configuration?.details[0].code}
                quantity={configuration?.details[0].quantity}
                price={configuration?.details[0].price}
                isEditable={
                  configuration?.details[0].isEditable && !readOnlyMode
                }
                stepNumber={configuration?.details[0].stepNumber}
                image={configuration?.details[0].imageUrl}
                regionObj={regionObj}
                flexWrapItem={false}
              />
              <div className="estimate-overview-element-code-extendable-container-flex-wrap">
                {configuration?.details?.slice(1).map((configDetail) => (
                  <EstimateOverviewElementDetails
                    key={configDetail.code}
                    configurationId={configuration.id}
                    title={configDetail.title}
                    details={configDetail.details}
                    code={configDetail.code}
                    quantity={configDetail.quantity}
                    price={configDetail.price}
                    isEditable={configDetail.isEditable && !readOnlyMode}
                    stepNumber={configDetail.stepNumber}
                    image={configDetail.imageUrl}
                    regionObj={regionObj}
                    flexWrapItem={true}
                  />
                ))}
              </div>
            </div>
          )}
          {summary && (
            <div
              onClick={() => handleOnClick(!isDetailsShown)}
              className="estimate-overview-element-code-extendable-button"
            >
              <div className="estimate-overview-element-code-extendable-button-content">
                {isDetailsShown ? (
                  <span
                    className="estimate-overview-configuration-button-arrow-up"
                    style={{ width: "10px", height: "10px" }}
                  ></span>
                ) : (
                  <span
                    style={{ width: "10px", height: "10px", color: "black" }}
                    className="estimate-overview-configuration-button-arrow-down"
                  ></span>
                )}
              </div>
            </div>
          )}
        </div>
      )}

      {readOnlyMode ? (
        <div
          className={
            "estimate-overview-element-button-container" +
            (isSmallScreen ? " smallScreen" : "")
          }
        >
          <EstimateOverviewButton
            style={{ width: isSmallScreen ? "100%" : "" }}
            toolTipText={getLocalizationText("EstimateOverview_Button_Export")}
            hide={type === "create"}
            onClick={() => {
              copyToClipboard();
            }}
            hasActionTooltip={true}
          >
            <span className="estimate-overview-configuration-button-copy"></span>
          </EstimateOverviewButton>
        </div>
      ) : (
        <div
          className={
            "estimate-overview-element-button-container" +
            (isSmallScreen ? " smallScreen" : "")
          }
          style={{
            opacity: isPopUpShown ? 0 : 1,
            pointerEvents: isPopUpShown ? "none" : "",
          }}
        >
          <EstimateOverviewButton
            style={{ width: isSmallScreen ? "100%" : "" }}
            toolTipText={getLocalizationText("EstimateOverview_Button_Remove")}
            hide={type === "create"}
            onClick={() => {
              setIsPopUpShown(true);
            }}
          >
            <span className="estimate-overview-configuration-button-delete"></span>
          </EstimateOverviewButton>

          <EstimateOverviewButton
            style={{ width: isSmallScreen ? "100%" : "" }}
            toolTipText={getLocalizationText("EstimateOverview_Button_Clone")}
            hide={type === "create"}
            onClick={() => {
              cloneConfiguration(configuration.id, () => refreshList());
            }}
          >
            <span className="estimate-overview-configuration-button-clone"></span>
          </EstimateOverviewButton>
          <EstimateOverviewButton
            style={{ width: isSmallScreen ? "100%" : "" }}
            toolTipText={getLocalizationText("EstimateOverview_Button_Export")}
            hide={type === "create"}
            onClick={() => {
              copyToClipboard();
            }}
            hasActionTooltip={true}
          >
            <span className="estimate-overview-configuration-button-copy"></span>
          </EstimateOverviewButton>
        </div>
      )}
    </EstimateOverviewCard>
  );
}
